  <!-- 新建客户档案 -->
<template>
  <div id="Custom_create">
    <div class="Custom_title">
      <div v-for="(item, index) in options" :key="index" :class="{ activeItem: currentTab === item.tabModName }" @click="itemClick(item.tabModName)">
        <span>{{ item.tabName }}</span>
      </div>
    </div>
    <component :is="currentTab" :common="commonData" @RELOADPAGE="reloadpage" />
  </div>
</template>
<script >
import baseinfo from "@/pages/Customers/CustomMOD/BaseInfo.vue";

export default {
  inject: ["reload"],
  components: {
    baseinfo,
  },
  data() {
    return {
      options: [
        {
          tabName: "基础信息",
          tabModName: "baseinfo",
        },
      ],
      commonData: {
        customerId: null,
      },
      currentTab: "baseinfo",
    };
  },
  methods: {
    itemClick(tab) {
      this.currentTab = tab;
    },
    reloadpage() {
      this.$TOOLS.closePage();
      this.$router.push({
        path: "/Customers/Custom",
        query: {
          isreload: "isreload",
        },
      });
    },
  },
};
</script>
<style scoped lang="less">
.Custom_title {
  background: #fff;
  border-bottom: 1px solid #cccccc;
  color: rgba(0, 0, 0, 0.802);
  display: flex;
  div {
    padding: 10px 26px;
    border: 1px solid #cccccc;
    cursor: pointer;
    border-right: none;
  }
  div:first-child {
    border-top-left-radius: 6px;
  }
  div:last-child {
    border-right: 1px solid #cccccc;
    border-top-right-radius: 6px;
  }

  .activeItem {
    background: #fff;
    color: #ef7c0a;
    border-bottom: #fff;
    // border-bottom: rgb(229, 49, 49) 2px solid;
  }
}
</style>
